module.exports = __webpack_public_path__ + "components/flag/static/square/ch-4b83600fcb8638d07476c943fd9a27da.svg";